// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Pa","segment":"i_Pb","active":"i_Pc","label":"i_Pd"};